import {
  createTableSortSchema,
  SortDirection,
  TableSort,
} from "@redotech/redo-views-common/table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const DeviceAuthSortKeySchema = z.enum([
  "deviceName",
  "lastUsedAt",
  "createdBy",
  "createdAt",
]);
export type DeviceAuthSortKey = z.infer<typeof DeviceAuthSortKeySchema>;

export const defaultDeviceAuthSort: TableSort<DeviceAuthSortKey> = {
  key: "deviceName",
  direction: SortDirection.ASC,
};

export const listDeviceAuth = {
  name: "listDeviceAuth" as const,
  input: z.object({
    sort: createTableSortSchema(DeviceAuthSortKeySchema).optional(),
  }),
  output: z.object({
    devices: z.array(
      z.object({
        id: z.string(),
        deviceName: z.string(),
        lastUsedAt: zExt.instant(),
        createdAt: zExt.instant(),
        createdBy: z.string(),
        createdByName: z.string().nullish(),
        lastIpAddress: z.string().nullish(),
        creationIpAddress: z.string().nullish(),
        userAgent: z.string().nullish(),
        isActive: z.boolean(),
      }),
    ),
  }),
};
